import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'dva'
import { getFeatureDisplayString } from '../../../lib/features'
import GHAnimatedLogo from '../../../assets/svg/GHAnimatedLogo'
import styles from './Loader.module.scss'

function LoaderSidebar(props) {
	return (
		<div className={styles.ghLoader}>
			<GHAnimatedLogo width={72} height={108} />
			<p>{props.loaderText}</p>
		</div>
	)
}

LoaderSidebar.propTypes = {
	loaderText: PropTypes.string,
}

export default connect((model, currentProps) => {
	const { collections: collectionModel, features: featuresModel } = model
	const { isCreatingItems, isDeletingItems, isEditingFeature, isSaving, isSelectingItems, isSortingItems } = featuresModel
	const { type = 'feature' } = currentProps // #TODO: Set props to determine if loader is for collection or feature 
	const { newFeature, selectedFeature } = featuresModel
	let featureType = null
	let loaderText = `Loading ${type === 'collection' ? 'Hunt' : 'Content'}...`	



	switch (type) {
		case 'collection':
			loaderText = 'Loading Hunt...'
		break
		case 'feature':
			loaderText = 'Loading Content...'
			featureType = newFeature && newFeature.ghType
			if (isCreatingItems) {
				if (featureType) {
					loaderText = `Creating ${getFeatureDisplayString(featureType)}...`
				} else {
					loaderText = 'Creating Content...'
				}
			} else if (isDeletingItems) {
				loaderText = 'Deleting Content...'
			} else if (isEditingFeature) {
				featureType = selectedFeature && selectedFeature.properties.ghType
				if (selectedFeature && selectedFeature.properties.ghType) {
					loaderText = `Editing ${getFeatureDisplayString(featureType)}...`
				} else {
					loaderText = 'Editing Content...'
				}
			} else if (isSaving) {
				if (featureType) {
					loaderText = `Saving ${getFeatureDisplayString(featureType)}...`
				} else {
					loaderText = 'Saving Content...'
				}
			} else if (isSelectingItems) {
				loaderText = 'Selecting Content...'
			} else if (isSortingItems) {
				loaderText = 'Sorting Content...'
			}
		break
	}
	return {
		loaderText,
	}
})(LoaderSidebar)
